import { observer } from 'mobx-react';
import { useAgentSearch } from '../AgentSearchContext';
import AgentSearchResultItem from './AgentSearchResultItem';
import AgentSearchTimeSection from './AgentSearchTimeSection';

const AgentSearchResults = observer(() => {
  const searchState = useAgentSearch();

  if (searchState.isLoading) {
    return (
      <div className="agent-search-results">
        <div className="agent-search-loading">
          <div className="agent-search-loading-text">Searching...</div>
        </div>
      </div>
    );
  }

  if (searchState.results.length === 0) {
    return (
      <div className="agent-search-results">
        <div className="agent-search-empty">
          <div className="agent-search-empty-text">
            {searchState.searchQuery ? 'No results found' : 'Start typing to search'}
          </div>
        </div>
      </div>
    );
  }

  const groupedResults = searchState.groupedResults;
  const timeGroups = ['Today', 'Yesterday', 'Last Week', 'Last Month', 'Older'];

  return (
    <div className="agent-search-results">
      <div className="agent-search-results-list">
        {timeGroups.map(timeGroup => {
          const results = groupedResults[timeGroup];
          if (!results || results.length === 0) return null;

          return (
            <div key={timeGroup} className="agent-search-time-group">
              <AgentSearchTimeSection title={timeGroup} />
              <div className="agent-search-group-items">
                {results.map(result => (
                  <AgentSearchResultItem
                    key={result.id}
                    result={result}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default AgentSearchResults;